import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  constructor(private http: HttpClient) {}

  clearCache(): Promise<void> {
    return new Promise(resolve => {
      const clearLocalStorage = () => {
        const keysToKeep = [
          'sv_session_data',
          'isLoggedin',
          'cookieConsent',
          'cookieConsentGranular',
          'cookieConsentDate',
          'build_hash',
          'clientAreaTourCompleted',
          'sv_clientarea_widgets_order',
        ];
        const preserved: { [key: string]: string | null } = {};
        keysToKeep.forEach(key => {
          preserved[key] = localStorage.getItem(key);
        });

        localStorage.clear();

        keysToKeep.forEach(key => {
          if (preserved[key]) {
            localStorage.setItem(key, preserved[key]!);
          }
        });
        resolve();
      };

      if (environment.production) {
        this.http.get('/clear-cache?no-cache=true', { responseType: 'text' }).subscribe({
          complete: () => clearLocalStorage(),
          error: error => {
            console.error('Error clearing cache:', error);
            clearLocalStorage();
          },
        });
      } else {
        clearLocalStorage();
      }
    });
  }
}
